import { Container } from 'react-bootstrap';

import styles from './Home.module.css';

const Home = () => {
  return (
    <Container className={styles.container} fluid>
      <video controls className={styles.video}>
        <source
          src="../../assets/fe-cipaa-2025.mp4"
          type="video/mp4"
        />
        O seu navegador não suporta a tag video
      </video>
    </Container>
  );
};

export default Home;
